// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".applicationDiv[data-v-7846af69]{padding-top:10px}h1[data-v-7846af69]{margin-top:4px}.v-menu__content[data-v-7846af69]{min-width:250px}.v-tab[data-v-7846af69]{padding:0 16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
